import { applyMiddleware, compose, createStore } from 'redux';
import { thunk } from 'redux-thunk';

import rootReducer from 'apps/promo/reducers';

const PROMO_STATE_KEYS = ['app', 'auth', 'language', 'form', 'messages', 'extra'];

const pickPromoState = (initState) => {
    if (!initState) {
        return initState;
    }
    return PROMO_STATE_KEYS.reduce((acc, key) => {
        if (Object.prototype.hasOwnProperty.call(initState, key)) {
            acc[key] = initState[key];
        }
        return acc;
    }, {});
};

export default function getStore(initState) {
    const devtoolsCompose = typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
    const composeEnhancers = !__isProd__ && devtoolsCompose ? devtoolsCompose({ trace: true, traceLimit: 25 }) : compose;
    const middlewareEnhancer = composeEnhancers(applyMiddleware(thunk));
    return createStore(rootReducer, pickPromoState(initState), middlewareEnhancer);
}
